import { createMutation, createResource } from "@evergis/react-fetching";
import { FilterDc } from "@evergis/api";

import { api as evergisApi } from "../evergis/api";

export const createFilter = createMutation(
  ({ filterData }: { filterData: FilterDc }) =>
    async api => ({
      data: { result: await api.filters.create(filterData) },
    }),
  { injected: evergisApi },
);

export const getFilter = createResource(
  (name: string) => async api => ({
    data: await api.filters.get(name),
  }),
  { injected: evergisApi },
);

export const updateFilter = createMutation(
  ({ name, filterData }: { name: string; filterData: FilterDc }) =>
    async api => ({
      data: { result: await api.filters.update(name, filterData) },
    }),
  { injected: evergisApi },
);
